import { createContext, useContext, useReducer } from "react";
import userData from "../resources/UsersData";
import reducer from '../reducer/UserReducer'
const UserContext = createContext()

const initailState = {
    users: [],
    singleUser: {},
  };

const UserProvider = ({children})=>{
  const [state, dispatch] = useReducer(reducer, initailState);

  const getUsers = () => {
    try {
      const users = userData;
      dispatch({ type: "SET_DATA", payload: users });
    } catch (err) {
      console.log("Error in getUser ftn in UserContext!!")
    }
  };

  const getSingleUser = (id) => {
    try {
      dispatch({ type: "SET_SINGLE_USER", payload: userData, id: id });
    } catch (err) {
        console.log("Error in getSingleUser ftn in UserContext!!")
    }
  };

  return (
    <UserContext.Provider value={{...state, getUsers, getSingleUser}}>
      {children}
    </UserContext.Provider>
  );

}

 //custom hook
 const useUserHook = () => {
    return useContext(UserContext);
  };

  export {UserContext,UserProvider,useUserHook}